import { render, staticRenderFns } from "./SpaceStorageMore.vue?vue&type=template&id=4d151f0e&"
import script from "./SpaceStorageMore.vue?vue&type=script&lang=js&"
export * from "./SpaceStorageMore.vue?vue&type=script&lang=js&"
import style0 from "./SpaceStorageMore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports